
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class MapComp extends Vue {
  @Prop({
    type: Array,
    default: () => [{ latitude: 39.908803, longitude: 116.397464 }]
  })
  position!: any;

  loading = true;
  mapLayer = undefined;
  map = undefined;

  mounted() {
    const mapScript = document.getElementById("QqMap");
    if (!mapScript && !(window as any).TMap) {
      const script = document.createElement("script");
      script.id = "QqMap";
      script.type = "text/javascript";
      script.src = `https://map.qq.com/api/gljs?v=1.exp&key=3MABZ-4G267-QOFXK-P4BJY-KEOJS-7BBD4&libraries=geometry`;
      document.body.appendChild(script);
      script.addEventListener("load", () => {
        this.loading = false;
        this.initMap();
      });
    } else {
      this.loading = false;
      this.initMap();
    }
  }

  initMap() {
    const mapItem = document.getElementById("map-item");
    const _TMap = (window as any).TMap;
    const [first] = this.position;
    const center = [first.latitude, first.longitude];
    this.map = new _TMap.Map(mapItem, {
      center,
      showControl: false,
      control: {
        compass: false,
        scale: false,
        zoom: false
      }
    });
    this.mapLayer = new _TMap.MultiMarker({
      map: this.map,
      styles: {
        marker: new _TMap.MarkerStyle({
          width: 20,
          height: 30,
          anchor: { x: 10, y: 30 },
          offset: { x: 0, y: 40 },
          backgroundColor: "#fff",
          backgroundBorderColor: "#000",
          backgroundBorderRadius: 6,
          backgroundBorderWidth: 1,
          padding: "5px 10px"
        })
      },
      geometries: []
    });
    this.updateMarker();
  }

  updateMarker() {
    const _TMap = (window as any).TMap;
    (this.mapLayer as any)?.setGeometries([]);
    (this.mapLayer as any)?.add(
      this.position.map((item: any) => {
        return {
          position: new _TMap.LatLng(item.latitude, item.longitude),
          id: "marker",
          styleId: "marker",
          content: `${item.latitude},${item.longitude}`
        };
      })
    );
  }

  setCenter(lat: number, lng: number) {
    const _TMap = (window as any).TMap;
    const center = new _TMap.LatLng(lat, lng);
    (this.map as any)?.setCenter(center);
  }

  @Watch("position")
  private changePosition() {
    this.updateMarker();
  }
}
